










import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class SlideReferenceItemPrefix extends Vue {
  @Prop({ type: String }) prefix!: string;
  @Prop({ type: Number }) index!: number;

  private nprefix: string = '';

  changePrefix(val: string) {
    this.nprefix = val;
    this.$emit('changed-prefix', { val, index: this.index });
  }

  mounted() {
    if (!this.prefix && this.prefix !== '') {
      return (this.nprefix = (this.index + 1).toString() + '.');
    } else {
      this.nprefix = this.prefix;
    }
  }

  @Watch('prefix')
  onPrefixChange(newPrefix: string) {
    if (newPrefix || newPrefix === '') {
      this.nprefix = newPrefix;
    } else {
      this.nprefix = (this.index + 1).toString() + '.';
    }
  }
}
